// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes NetworksIconsDisplay_scrollIn__5hONM {
  0% {
    opacity: 0;
    transform: translateX(100%) rotate(400);
  }
  75% {
    opacity: 0.8;
    transform: translateX(-10%); /* Move towards the final position */
  }
  100% {
    opacity: 1;
    transform: translateX(0); /* End at the final position */
  }
}
@keyframes NetworksIconsDisplay_rotateLikeWashingMachine__F5hoY {
  0% {
    opacity: 0;
    transform: translateX(100%) rotate(0deg); /* Start off-screen to the right, no rotation */
  }
  25% {
    opacity: 0.3;
    transform: translateX(50%) rotate(180deg); /* Halfway through the entrance, half rotation */
  }
  50% {
    opacity: 0.6;
    transform: translateX(25%) rotate(360deg); /* Further in, full rotation */
  }
  75% {
    opacity: 0.8;
    transform: translateX(-10%) rotate(540deg); /* Past final position, one and a half rotations */
  }
  100% {
    opacity: 1;
    transform: translateX(0) rotate(720deg); /* End at final position, two full rotations */
  }
}
@keyframes NetworksIconsDisplay_spin3D__6E\\+Xb {
  0% {
    transform: translateX(1000%);
    opacity: 0;
    filter: blur(50px); /* Start with a pixelated (blurred) appearance */
  }
  100% {
    transform: translateX(0);
    opacity: 1;
    filter: blur(0); /* Transition to a clear image */
  }
}
.NetworksIconsDisplay_networks-icons-container__BObFk {
  display: flex;
  flex-direction: row; /* Change to row direction for horizontal scrolling */
  overflow-x: auto; /* Enable horizontal scrolling */
  max-width: 100%; /* Set a max width for the container, adjust as needed */
  gap: 1rem;
  align-items: end;
  padding: 1rem;
  max-width: 200px;
  position: relative; /* Add this line to establish a stacking context */
  animation: NetworksIconsDisplay_scrollIn__5hONM 0.5s ease-out forwards;
  perspective: 1000px; /* Adds depth to the 3D transformations */
  /* Apply a smooth scrolling effect */
  scroll-behavior: smooth;
  /* Styles for the FontAwesome icon */
}
.NetworksIconsDisplay_networks-icons-container__BObFk .NetworksIconsDisplay_icon-container__Hdyi2 {
  flex: 0 0 auto;
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease; /* Smooth transition for hover effect */
  animation: NetworksIconsDisplay_spin3D__6E\\+Xb 1s ease-out forwards;
  /* Hover effect: scale up and add a shadow */
}
.NetworksIconsDisplay_networks-icons-container__BObFk .NetworksIconsDisplay_icon-container__Hdyi2:hover {
  transform: scale(1.2);
}
.NetworksIconsDisplay_networks-icons-container__BObFk .NetworksIconsDisplay_fa-icon__uqhBo {
  border-radius: 50%;
  width: 2rem; /* Increased icon size */
  height: 2rem;
  transition: filter 0.3s ease; /* Smooth transition for filter effects */
  /* Interactive filter effects on hover */
}
.NetworksIconsDisplay_networks-icons-container__BObFk .NetworksIconsDisplay_fa-icon__uqhBo:hover {
  filter: brightness(1.2) contrast(1.2);
}

/* Hide scrollbar for webkit-based browsers */
.NetworksIconsDisplay_networks-icons-container__BObFk::-webkit-scrollbar {
  width: 0.2rem; /* Set the width of the scrollbar to zero */
  background-color: transparent; /* Set the background color to transparent */
}

/* Hide scrollbar thumb for webkit-based browsers */
.NetworksIconsDisplay_networks-icons-container__BObFk::-webkit-scrollbar-thumb {
  background-color: transparent; /* Set the scrollbar thumb color to transparent */
}

/* Media query for responsiveness */
@media (max-width: 600px) {
  .NetworksIconsDisplay_networks-icons-container__BObFk {
    justify-content: center;
    gap: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/NetworksIconsDisplay/NetworksIconsDisplay.module.scss"],"names":[],"mappings":"AAAA;EACE;IACE,UAAA;IACA,uCAAA;EACF;EACA;IACE,YAAA;IACA,2BAAA,EAAA,oCAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA,EAAA,8BAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;IACA,wCAAA,EAAA,+CAAA;EAAF;EAEA;IACE,YAAA;IACA,yCAAA,EAAA,gDAAA;EAAF;EAEA;IACE,YAAA;IACA,yCAAA,EAAA,8BAAA;EAAF;EAEA;IACE,YAAA;IACA,0CAAA,EAAA,kDAAA;EAAF;EAEA;IACE,UAAA;IACA,uCAAA,EAAA,8CAAA;EAAF;AACF;AAGA;EACE;IACE,4BAAA;IACA,UAAA;IACA,kBAAA,EAAA,gDAAA;EADF;EAGA;IACE,wBAAA;IACA,UAAA;IACA,eAAA,EAAA,gCAAA;EADF;AACF;AAKA;EACE,aAAA;EACA,mBAAA,EAAA,qDAAA;EACA,gBAAA,EAAA,gCAAA;EACA,eAAA,EAAA,wDAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA,EAAA,kDAAA;EACA,sEAAA;EACA,mBAAA,EAAA,yCAAA;EAIA,oCAAA;EACA,uBAAA;EAeA,oCAAA;AApBF;AAOE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA,EAAA,uCAAA;EACA,mEAAA;EAEA,4CAAA;AANJ;AAOI;EACE,qBAAA;AALN;AAUE;EACE,kBAAA;EACA,WAAA,EAAA,wBAAA;EACA,YAAA;EACA,4BAAA,EAAA,yCAAA;EAEA,wCAAA;AATJ;AAUI;EACE,qCAAA;AARN;;AAaA,6CAAA;AACA;EACE,aAAA,EAAA,2CAAA;EACA,6BAAA,EAAA,4CAAA;AAVF;;AAaA,mDAAA;AACA;EACE,6BAAA,EAAA,iDAAA;AAVF;;AAaA,mCAAA;AACA;EACE;IACE,uBAAA;IACA,WAAA;EAVF;AACF","sourcesContent":["@keyframes scrollIn {\n  0% {\n    opacity: 0;\n    transform: translateX(100%) rotate(400);\n  }\n  75% {\n    opacity: 0.8;\n    transform: translateX(-10%); /* Move towards the final position */\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0); /* End at the final position */\n  }\n}\n\n@keyframes rotateLikeWashingMachine {\n  0% {\n    opacity: 0;\n    transform: translateX(100%) rotate(0deg); /* Start off-screen to the right, no rotation */\n  }\n  25% {\n    opacity: 0.3;\n    transform: translateX(50%) rotate(180deg); /* Halfway through the entrance, half rotation */\n  }\n  50% {\n    opacity: 0.6;\n    transform: translateX(25%) rotate(360deg); /* Further in, full rotation */\n  }\n  75% {\n    opacity: 0.8;\n    transform: translateX(-10%) rotate(540deg); /* Past final position, one and a half rotations */\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0) rotate(720deg); /* End at final position, two full rotations */\n  }\n}\n\n@keyframes spin3D {\n  0% {\n    transform: translateX(1000%) ;\n    opacity: 0;\n    filter: blur(50px); /* Start with a pixelated (blurred) appearance */\n  }\n  100% {\n    transform: translateX(0) ;\n    opacity: 1;\n    filter: blur(0); /* Transition to a clear image */\n  }\n}\n\n\n.networks-icons-container {\n  display: flex;\n  flex-direction: row; /* Change to row direction for horizontal scrolling */\n  overflow-x: auto; /* Enable horizontal scrolling */\n  max-width: 100%; /* Set a max width for the container, adjust as needed */\n  gap: 1rem;\n  align-items: end;\n  padding: 1rem;\n  max-width: 200px;\n  position: relative; /* Add this line to establish a stacking context */\n  animation: scrollIn 0.5s ease-out forwards;\n  perspective: 1000px; /* Adds depth to the 3D transformations */\n\n\n\n  /* Apply a smooth scrolling effect */\n  scroll-behavior: smooth;\n\n  .icon-container {\n    flex: 0 0 auto;\n    position: relative;\n    cursor: pointer;\n    transition: transform 0.3s ease; /* Smooth transition for hover effect */\n    animation: spin3D 1s ease-out forwards;\n\n    /* Hover effect: scale up and add a shadow */\n    &:hover {\n      transform: scale(1.2);\n    }\n  }\n\n  /* Styles for the FontAwesome icon */\n  .fa-icon {\n    border-radius: 50%;\n    width: 2rem; /* Increased icon size */\n    height: 2rem;\n    transition: filter 0.3s ease; /* Smooth transition for filter effects */\n\n    /* Interactive filter effects on hover */\n    &:hover {\n      filter: brightness(1.2) contrast(1.2);\n    }\n  }\n}\n\n/* Hide scrollbar for webkit-based browsers */\n.networks-icons-container::-webkit-scrollbar {\n  width: 0.2rem; /* Set the width of the scrollbar to zero */\n  background-color: transparent; /* Set the background color to transparent */\n}\n\n/* Hide scrollbar thumb for webkit-based browsers */\n.networks-icons-container::-webkit-scrollbar-thumb {\n  background-color: transparent; /* Set the scrollbar thumb color to transparent */\n}\n\n/* Media query for responsiveness */\n@media (max-width: 600px) {\n  .networks-icons-container {\n    justify-content: center;\n    gap: 0.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"networks-icons-container": `NetworksIconsDisplay_networks-icons-container__BObFk`,
	"scrollIn": `NetworksIconsDisplay_scrollIn__5hONM`,
	"icon-container": `NetworksIconsDisplay_icon-container__Hdyi2`,
	"spin3D": `NetworksIconsDisplay_spin3D__6E+Xb`,
	"fa-icon": `NetworksIconsDisplay_fa-icon__uqhBo`,
	"rotateLikeWashingMachine": `NetworksIconsDisplay_rotateLikeWashingMachine__F5hoY`
};
export default ___CSS_LOADER_EXPORT___;
